import { IFramePlayerPostMessageHub } from 'iframe/ts/player/controller/IFramePlayerPostMessageHub';
import { IFrameTagEmbedManager } from 'iframe/ts/player/controller/IFrameTagEmbedManager';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { IFramePlayerModel } from 'iframe/ts/player/model/IFramePlayerModel';
import { IFrameDependenciesLoader } from 'iframe/ts/player/utilities/IFrameDependenciesLoader';
import { IFrameRuntimeVO } from 'iframe/ts/player/utilities/IFrameRuntimeVO';
import { EventDispatcher } from 'library/ts/events/EventDispatcher';
import { Cookies } from 'library/ts/utilities/Cookies';
import { LogService } from 'library/ts/utilities/logger/LogService';
import { ConnectionMonitor } from 'library/ts/utilities/network/ConnectionMonitor';
export class IFramePlayer {
    #connectionMonitor;
    #runtimeVO;
    #logger;
    #eventDispatcher;
    #smartTag;
    #model;
    #tagEmbedManager;
    #postMessageHub;
    #dependenciesLoader;
    constructor(para = window?.PARA) {
        this.#logger = LogService.create({ prefixes: ['IFramePlayer:'] });
        setTimeout(() => {
            this.#runtimeVO = new IFrameRuntimeVO();
            switch (this.#runtimeVO === null) {
                case true:
                    break;
                case false:
                    this.utilities.Delay.delay()
                        .then(() => this.#start());
                    break;
            }
        });
    }
    get name() {
        return 'IFramePlayer';
    }
    get info() {
        return {
            version: window.PlayerServicesProjectInfo.release_version,
            date: window.PlayerServicesProjectInfo.app_compile_time.tag.token
        };
    }
    get startTime() {
        return window?.PARA?.PlayerServices?.StartTime;
    }
    get utilities() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    get cookies() {
        return Cookies.getInstance();
    }
    get capabilities() {
        return window?.PARA?.PlayerServices?.Capabilities;
    }
    get online() {
        return this.#connectionMonitor !== undefined
            ? this.#connectionMonitor.onLine
            : undefined;
    }
    get runtimeVO() {
        return this.#runtimeVO;
    }
    get scripted() {
        return this.utilities.Type.isString(this?.runtimeVO?.uuid) && !this.utilities.Type.isEmpty(this?.runtimeVO?.uuid);
    }
    get model() {
        return this.#model;
    }
    get postMessageHub() {
        return this.#postMessageHub;
    }
    get eventDispatcher() {
        return this.#eventDispatcher;
    }
    #start = () => {
        this.#logger.log(this.name, 'Start');
        this.utilities.Delay.delay()
            .then(() => this.#eventDispatcher = new EventDispatcher(this?.name))
            .then(() => this.#dependenciesLoader = new IFrameDependenciesLoader(this))
            .then(() => this.#postMessageHub = new IFramePlayerPostMessageHub(this))
            .then(() => this.#model = new IFramePlayerModel(this))
            .then(() => this.#connectionMonitor = new ConnectionMonitor(this.utilities, this.capabilities, this.#connectionManagerCallback))
            .then(() => this.#tagEmbedManager = new IFrameTagEmbedManager(this))
            .then(() => {
            this.#model.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_SMART_TAG_IMPORT_REQUEST,
                iframePlayer: this,
                target: this,
                targetName: this.name
            });
        });
    };
    #connectionManagerCallback = (online) => {
    };
    onSmartTagReady = (smartTag) => {
        if (!this.utilities.Type.isEmpty(this.#smartTag)) {
            return;
        }
        this.#smartTag = smartTag;
        this.#logger.log(this.name, 'onSmartTagReady:', smartTag, 'Create instance of Tag');
        this.#model.dispatchIFramePlayerEvent({
            type: IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK,
            iframePlayer: this,
            data: {
                smartTag: this.#smartTag
            },
            target: this,
            targetName: this.name
        });
    };
}
